import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius } from '~styles/theme.stylex';
export const styles = {
  wrap: {
    display: "x1s85apg xk8jvp7",
    height: "xr004xx",
    marginBottom: "x1eq25fj",
    borderRadius: "x3rajx7",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    backgroundColor: "x19l0dny",
    $$css: true
  },
  map: {
    width: "xh8yej3",
    height: "x5yr21d",
    $$css: true
  }
};